<template>
  <div class="option">
    <p class="option__text">{{initialText}}</p>
    <v-progress-linear
      v-model="percentage"
      height="15"
      color="green"
    >
      <strong>{{ percentage }}%</strong>
    </v-progress-linear>
  </div>
</template>

<script>
export default {
  /**
   * Опции опроса.
   */
  name: 'WhatsAppOption',
  data() {
    return {
      /**
       * @description Процент
       * @type {Number}
       */
      percentage: this.initialPercentage,
    };
  },
  props: {
    /**
     * @description Изначальный текст.
     * @type String
     */
    initialText: { type: String, required: true, default: () => '' },
    /**
     * @description Изначальный процент.
     * @type Number
     */
    initialPercentage: { type: Number, default: () => 0 },
  },
};

</script>

<style scoped lang="scss">

</style>
